import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./consultaNominas/consultaNominas.scss";
import { memo } from "react";
import React, { useState } from "react";
import Titulo from "../../atoms/titles/Titulo";

import Button from "../../atoms/buttons/Button";

registerLocale("es", es);

const Confirm = (object) => {
   
   

    // const [mensaje, setMensaje] = useState();
    const [showConfirm] = useState(false);
 



    // useEffect(() => {
    //     setLoading(true);
    // }, [token]);

    function modalConfirm() {
        return (
            <Modal
                className={`infModal fechas ${showConfirm ? "opacity-0" : "opacity-100"
                    } `}
                show={object.show}
                onHide={object.handleClose}
                backdrop="static"
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Titulo titulo={object.titulo} tipo={"tituloModal"} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container containerConfirm">
                        <div className="col p-3">
                            <p>{object.mensaje}</p>
                        </div>
                        <div className="col  mx-auto">
                            <div className="d-flex justify-content-around">
                                {!object.respuesta ? (<>
                                    <Button
                                        id="consultaIRPF"
                                        clases="btn-card"
                                        nombre={
                                            <>
                                                Aceptar
                                            </>
                                        }
                                        tipo="button"
                                        funcion={object.funcion}
                                    /></>) : null}

                                <Button
                                    id="consultaIRPF"
                                    clases="bg-danger rounded"
                                    nombre={
                                        <>
                                            Cancelar
                                        </>
                                    }
                                    tipo="submit"
                                    funcion={object.handleClose}
                                />
                            </div>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    return <>{modalConfirm()}</>;
};

export default memo(Confirm);
